import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Plan action request builders.
 *
 * The v1 PlanResource stopped serializing tiers as an inline attribute in
 * Dec 2025 (tio-api replaced `attribute :tiers` with `relationship :tiers`),
 * so a plan loaded through /me carries no tier data. These builders read the
 * related-tier records directly from the JSONAPI relationship route that
 * replaced the attribute.
 */

const plansUrlOptions: QueryUrlOptions = {
  identifier: { type: 'plans' },
  op: 'query',
  resourcePath: 'plans',
};

function plansUrl(path?: string): string {
  const base = buildBaseURL(plansUrlOptions);
  return path ? `${base}/${path.replace(/^\/+/, '')}` : base;
}

/**
 * GET /plans/:id/tiers (jsonapi_related_resources :tiers)
 *
 * Raw JSONAPI document (`{ data: [{ attributes: { fromCycle, amount, ... } }] }`,
 * amount in cents); the call site reads it off `content`. Tier order is not
 * guaranteed by the API — sort by fromCycle before use (the removed inline
 * attribute was ordered fromCycle ASC).
 */
export function planTiersRequest(planId: string): RequestInfo {
  return {
    url: plansUrl(`${planId}/tiers`),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
